import React, { useEffect, useState } from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { formValueSelector } from "redux-form";

import ShowDescription from "../../ShowDescription/ShowDescription";
import SubCategory from "../ViewSubCategory/SubCategory/SubCategory";
import LocationSearchForm from '../LocationSearchForm/LocationSearchForm';
import CommonModal from "../../Modal/CommonModal";
import JobDescription from "../ViewSubCategory/JobDescription/JobDescription";
import NotFound from "../../NotFound/NotFound";
import ViewCategorySkeleton from "../../Skeleton/Categories/ViewCategorySkeleton/ViewCategorySkeleton";
import SubCategorySkeleton from "../../Skeleton/Categories/SubCategorySkeleton/SubCategorySkeleton";

import { closeHeaderModal } from "../../../actions/siteadmin/modalActions";
import messages from "../../../locale/messages";
import { api, categoryUploadDir } from "../../../config";

import s from "./ViewCategory.css"



const ViewCategory = (props) => {
    const { data, loading, preferredCurrency, location, jobDescription, intl: { formatMessage }, closeHeaderModal } = props;
    const pricingType = data?.getCategory?.result?.pricingType;

    const [subCategoryLoading, setSubCategoryLoading] = useState(false)

    const closeJobDescriptionModal = () => {
        closeHeaderModal('jobDescription');
    }

    useEffect(() => {
        if (location?.location?.lat && location?.location?.lng) {
            setSubCategoryLoading(true)
            const timer = setTimeout(() => {
                setSubCategoryLoading(false)
            }, 1500)
            return () => clearTimeout(timer)
        };

    }, [location])

    if (loading) {
        return <ViewCategorySkeleton />
    }
    return (
        <>
            <CommonModal
                title={formatMessage(messages.jobDescription)}
                onHide={closeJobDescriptionModal}
                modalStatus={jobDescription} >
                <JobDescription />
            </CommonModal>
            {
                ((data?.getCategory?.result?.status == 'Inactive') || (!loading && !data?.getCategory?.result)) ? <NotFound /> : <div className={s.viewCategoryContainer}>

                    <>
                        <div className={s.viewCategoryLsBox}>
                            <div>
                                <div className={s.viewCategoryImgContainer}>
                                    <img
                                        src={`${api.apiEndpoint}${categoryUploadDir}${data?.getCategory?.result?.bannerImage}`}
                                        alt={data?.getCategory?.result?.name || ''}
                                    />
                                </div>
                                <div className={s.viewCategoryInfoContainer}>
                                    <div className={s.viewCategoryInfoTitle}>{data?.getCategory?.result?.name}</div>
                                    <ShowDescription description={data?.getCategory?.result?.description} count={250} className={s.viewCategoryInfoDesc} />
                                </div>
                            </div>
                            {
                                (location?.location?.lat && location?.location?.lng) && (
                                    subCategoryLoading ? <SubCategorySkeleton /> :
                                        <SubCategory
                                            id={data?.getCategory?.result?.id}
                                            pricingType={pricingType}
                                            preferredCurrency={preferredCurrency}
                                            lat={location?.location?.lat}
                                            lng={location?.location?.lng}
                                        />
                                )

                            }
                        </div>
                        <div className={s.viewCategoryRsBox}>
                            <div className={s.viewCategorySearchContainer}>
                                <LocationSearchForm initialValues={data?.getCategory?.result} />
                            </div>
                        </div>
                    </>

                </div>
            }
        </>
    )
}
const selector = formValueSelector('LocationSearchForm')
const mapState = (state) => ({
    preferredCurrency: state?.userAccount?.data?.preferredCurrency,
    location: selector(state, 'location'),
    jobDescription: state.adminModalStatus.jobDescription,
})
const mapDispatch = {
    closeHeaderModal
}
export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(ViewCategory)));